import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=daf2e7c2&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=ts&"
export * from "./file-list.vue?vue&type=script&lang=ts&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=daf2e7c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf2e7c2",
  null
  
)

export default component.exports